import React from 'react'
import '../assets/css/skills.css'

const Skills = () => {
  return (
   <>
   <section id="skills">
     <div className="progress-container">
       <div className="progress-title">
         <h2>Evolution de mes acquis</h2>

         <h3>Mes Compétences</h3>
       </div>
       <div className="progress-row2">
         <div className="lang">

            {/* Express */}
            <div className="mylang" title="NodeJS">
               <div className="lang-info">
                  <div className="lang-img">
                     <i class="fa-brands fa-node"></i>
                  </div>
                  <h3>NodeJS</h3>
                  <p className="Intermediate">Intermédiaire</p>
               </div>
            </div>

            {/* Spring */}
            <div className="mylang" title="SpringBoot">
               <div className="lang-info">
                  <div className="lang-img">
                     <i class="fa-brands fa-java"></i>
                  </div>
                  <h3>SpringBoot</h3>
                  <p className="Intermediate">Intermédiaire</p>
               </div>
            </div>

            {/* Laravel */}
            <div className="mylang" title="Laravel">
               <div className="lang-info">
                  <div className="lang-img">
                     <i class="fa-brands fa-laravel"></i>
                  </div>
                  <h3>Laravel</h3>
                  <p className="Intermediate">Intermédiaire</p>
               </div>
            </div>

            {/* Flask */}
            <div className="mylang" title="Flask">
               <div className="lang-info">
                  <div className="lang-img">
                     <i class="fa-brands fa-python"></i>
                  </div>
                  <h3>Flask</h3>
                  <p className="Junior">Junior</p>
               </div>
            </div>

            {/* React */}
            <div className="mylang" title="React JS">
               <div className="lang-info">
                  <div className="lang-img">
                     <i class="fa-brands fa-react"></i>
                  </div>
                  <h3>React JS</h3>
                  <p className="Intermediate">Intermédiaire</p>
               </div>
            </div>

            {/* Angular */}
            <div className="mylang" title="Angular">
               <div className="lang-info">
                  <div className="lang-img">
                  <i class="fa-brands fa-angular"></i>
                  </div>
                  <h3>Angular</h3>
                  <p className="Intermediate">Intermédiaire</p>
               </div>
            </div>

            {/* Git */}
            <div className="mylang" title="Git">
               <div className="lang-info">
                  <div className="lang-img">
                     <i class="fa-brands fa-git"></i>
                  </div>
                  <h3>GIT</h3>
                  <p className="Intermediate">Intermédiaire</p>
               </div>
            </div>

            {/* Next JS */}
            <div className="mylang" title="DevOps">
               <div className="lang-info">
                  <div className="lang-img">
                  <i class="fa-brands fa-docker"></i>
                  </div>
                  <h3>DevOps</h3>
                  <p className="Intermediate">Intermédiaire</p>
               </div>
            </div>

            {/* Vue */}
            <div className="mylang" title="Vue JS">
               <div className="lang-info">
                  <div className="lang-img">
                     <i class="fa-brands fa-vuejs"></i>
                  </div>
                  <h3>Vue JS</h3>
                  <p className="Intermediate">Intermédiaire</p>
               </div>
            </div>

            {/* React Native*/}
            <div className="mylang" title="React Native">
               <div className="lang-info">
                  <div className="lang-img">
                     <i class="fa-brands fa-react"></i>
                  </div>
                  <h3>React Native</h3>
                  <p className="Intermediate">Intermédiaire</p>
               </div>
            </div>


            {/* js */}
            <div className="mylang" title="javaScript">
               <div className="lang-info">
                  <div className="lang-img">
                     <i class="fa-brands fa-square-js"></i>
                  </div>
                  <h3>JavaScript</h3>
                  <p className="Intermediate">Intermédiaire</p>
               </div>
            </div>

            {/* java */}
            <div className="mylang" title="Java">
               <div className="lang-info">
                  <div className="lang-img">
                     <i class="fa-brands fa-java"></i>
                  </div>
                  <h3>Java</h3>
                  <p className="Intermediate">Intermédiaire</p>
               </div>
            </div>

            {/* Php */}
            <div className="mylang" title="Php">
               <div className="lang-info">
                  <div className="lang-img">
                     <i class="fa-brands fa-php"></i>
                  </div>
                  <h3>Php</h3>
                  <p className="Intermediate">Intermédiaire</p>
               </div>
            </div>

            {/* Python */}
            <div className="mylang" title="Python">
               <div className="lang-info">
                  <div className="lang-img">
                     <i class="fa-brands fa-python"></i>
                  </div>
                  <h3>Python</h3>
                  <p className="Junior">Junior</p>
               </div>
            </div>
         </div>
       </div>
     </div>
   </section>
 </>
  )
}

export default Skills